import Vue from 'vue';
export default Vue.extend({
    inheritAttrs: false,
    props: {
        /** color of button: blue, green, orange, red, white, transparent.  Defaults to grey. */
        color: { type: String, required: false, default: null },
        /** size of button: mini, tiny, small, large, big, huge, massive: default is between small & large */
        size: { type: String, required: false, default: null },
        /** button type attribute, e.g "submit" */
        type: { type: String, required: false, default: 'button' },
        /** reduces button padding */
        compact: { type: Boolean, required: false, default: false },
        /** makes ends of button rounded */
        round: { type: Boolean, required: false, default: false },
        /** removes smoothed corners,  making the corners exact points */
        sharp: { type: Boolean, required: false, default: false },
        routeTo: { type: Object, required: false, default: null }
        // future additions ?
        // border
        // dark
        // inverse
        // outline ?
    },
    computed: {
        disabled() {
            if (this.$attrs) {
                if (this.$attrs.disabled === undefined)
                    return false;
                if (this.$attrs.disabled === false)
                    return false;
                if (this.$attrs.disabled === true)
                    return true;
            }
            return false;
        }
    }
});
